import React, { useEffect, useRef, useMemo } from 'react'

import useDominantSpeaker from 'hooks/useDominantSpeaker/useDominantSpeaker'
import usePublications from 'hooks/usePublications/usePublications'
import useTrack from 'hooks/useTrack/useTrack'
import useVideoContext from 'hooks/useVideoContext/useVideoContext'
import { getRandomElementFromArray } from 'utils/utils'

import { Video } from './styles'

const PIPHandler = () => {
    const dominantSpeaker = useDominantSpeaker()
    const dominantSpeakerPubs = usePublications(dominantSpeaker)
    const dominantSpeakerVideoPub = dominantSpeakerPubs.find(
        p => p.kind === 'video' && p.trackName !== 'screen'
    )
    const dominantSpeakerVideoTrack = useTrack(
        dominantSpeakerVideoPub,
        dominantSpeaker
    )

    const { room } = useVideoContext()
    const randomSpeaker = getRandomElementFromArray(
        Array.from(room.participants.values())
    )
    const randomSpeakerPubs = usePublications(randomSpeaker)
    const randomSpeakerVideoPub = randomSpeakerPubs.find(
        p => p.kind === 'video' && p.trackName !== 'screen'
    )
    const randomSpeakerVideoTrack = useTrack(
        randomSpeakerVideoPub,
        randomSpeaker
    )

    const videoRef = useRef(null)

    useEffect(() => {
        const videoTrack = dominantSpeakerVideoTrack ?? randomSpeakerVideoTrack
        if (videoTrack && videoRef.current) {
            videoTrack.attach(videoRef.current)
        }

        return () => {
            if (videoTrack && videoRef.current) {
                videoTrack.detach(videoRef.current)
            }
        }
    }, [dominantSpeakerVideoTrack, randomSpeakerVideoTrack, videoRef.current])

    const PIPVideo = useMemo(
        () => (
            <Video
                ref={videoRef}
                id="pipVideo"
                width={1}
                height={1}
                muted
                autoPlay
                playsInline
                webkit-playsinline="true"
            />
        ),
        []
    )
    return PIPVideo
}

export default PIPHandler
